import script from "./ShortcutsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutsList.vue?vue&type=script&setup=true&lang=js"

import "./ShortcutsList.vue?vue&type=style&index=0&id=cbb66ef0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbb66ef0"]])

export default __exports__